import React, {Component} from 'react'

import style from './resultReviews.module.scss'
import Slider from 'react-slick'

class ResultReviews extends Component {
   render() {
      const {reviews, settings} = this.props
      return (
         document.body.clientWidth >= 768
            ?
            <ul className={style.resultReviews__reviewList}>
               {reviews.map(({iamge, name, body, image_id}) => (
                  <li className={style.resultReviews__reviewItem} key={image_id}>
                     {
                        !!iamge ? (<img className={style.resultReviews__reviewImg} src={iamge} alt={name} />) : ''
                     }
                     <span className={style.resultReviews__reviewName}>{name}</span>
                     <p className={style.resultReviews__review}>{body}</p>
                  </li>
               ))}
            </ul>
            :
            <Slider {...settings} className={style.resultReviews__slider}>
               {reviews.map(({iamge, name, body, image_id}) => (
                  <li className={style.resultReviews__reviewItem} key={image_id}>
                     {
                        !!iamge ? (<img className={style.resultReviews__reviewImg} src={iamge} alt={name} />) : ''
                     }
                     <span className={style.resultReviews__reviewName}>{name}</span>
                     <p className={style.resultReviews__review}>{body}</p>
                  </li>
               ))}
            </Slider>
      )
   }
}

export default ResultReviews